import { Chip } from '@mui/material';
import styled from 'styled-components';

import { COLORS } from '../../../theme';

export const Component = styled(Chip)`
  &.MuiChip-root {
    min-width: 32px;
    color: ${COLORS.black80};
    background: ${COLORS.black06};
    border: 1px solid ${COLORS.black20};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};
    cursor: inherit;
  }

  .MuiChip-label {
    padding: ${({ theme }) => theme.spacing.s1}
      ${({ theme }) => theme.spacing.s3};
    font-size: ${({ theme }) => theme.fontSize.body2};
    font-weight: 500;
  }

  && .MuiChip-icon {
    margin-right: -${({ theme }) => theme.spacing.s1};
    margin-left: ${({ theme }) => theme.spacing.s1};
    font-size: 20px;

    path {
      fill: ${COLORS.black50};
    }
  }

  && .MuiChip-deleteIcon {
    margin-right: ${({ theme }) => theme.spacing.s2};
    margin-left: 0;
    font-size: 12px;

    path {
      fill: ${COLORS.black60};
    }
  }
`;
